import { Form, FormContext, Select } from "dash-ui";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { FormFields } from "../../constants/constants";
import { PropertyTransactionTypesEnum } from "dash-common";
import { camelCase } from "lodash";

function TransactionTypeSection() {
  const { formState, stateHandlers } = useContext(FormContext);

  const { t } = useTranslation(["forms", "forms", "pages"]);

  return (
    <Form.Group w="100%">
      <Form.Label>{t("labels.propertyTransactionType")}</Form.Label>
      <Select
        w="100%"
        mr={3}
        isSearchable={false}
        placeholder={
          formState[FormFields.TransactionType]
            ? t(
                `forms:labels.propertyTransactionTypes.${camelCase(
                  formState[FormFields.TransactionType]
                )}`
              )
            : t(
                `forms:labels.propertyTransactionTypes.${camelCase(
                  PropertyTransactionTypesEnum.FOR_SALE
                )}`
              )
        }
        onChanged={(value) => stateHandlers[FormFields.TransactionType](value)}
        value={formState[FormFields.TransactionType]}
        options={Object.values(PropertyTransactionTypesEnum).map((item) => ({
          label: t(`forms:labels.propertyTransactionTypes.${camelCase(item)}`),
          value: item,
        }))}
      />
    </Form.Group>
  );
}

export default TransactionTypeSection;
